import React from "react";
import { useScrollReveal } from "./useScrollReveal";

interface CTABannerProps {
	variant?: "mid" | "bottom";
}

export function CTABanner({ variant = "bottom" }: CTABannerProps) {
	const ref = useScrollReveal();

	return (
		<section ref={ref} className="py-20 md:py-28">
			<div className="mx-auto max-w-7xl px-6">
				<div className="scroll-reveal relative overflow-hidden rounded-2xl border border-white/10 bg-gradient-to-br from-zinc-900 to-zinc-950 p-12 text-center md:p-16">
					{/* Background glow */}
					<div
						className="pointer-events-none absolute inset-0"
						style={{
							background:
								"radial-gradient(circle at 50% 120%, rgba(219,36,30,0.1) 0%, transparent 60%)",
						}}
					/>

					<div className="relative">
						<h2 className="text-3xl font-bold tracking-tight text-white md:text-4xl">
							{variant === "mid"
								? "Ready to organize your comps like a pro?"
								: "Start organizing your comps today"}
						</h2>
						<p className="mx-auto mt-4 max-w-xl text-lg text-zinc-400">
							{variant === "mid"
								? "Join real estate professionals who use COMPS.red to organize their deal flow."
								: "Free 14-day trial. No credit card required. Set up in under a minute."}
						</p>
						<div className="mt-8 flex flex-col items-center gap-4 sm:flex-row sm:justify-center">
							<a
								href="/signup"
								className="rounded-lg bg-[#db241e] px-8 py-3 text-sm font-medium text-white transition-all hover:bg-[#c41f1a] hover:shadow-lg hover:shadow-red-900/30"
							>
								Get Started Free
							</a>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
